module.exports = __webpack_public_path__ + "media/images/v2/Untitled-1-Recovered-7fb91862295130e955fafecbb418ac6b.png";